<span class="mvd_alert--message__warning" *ngIf="!curbSideDelivery"><i class="material-icons"></i> The physical address is excluded from receiving postal deliveries. <strong>Please obtain customer's mailing address.</strong></span>

<h2>
    {{ componentTitle }}
    <button class="icon--add btn--default" type="button" *ngIf="showAddLink && canEdit" (click)="updateAddress(0)">{{ addLinkText }}</button>
    <button class="icon--history btn--default" type="button" (click)="showHistory()" *ngIf="showHistoryButton && !isACP">View History</button>
</h2>
<p-table #dt [value]="addresses" styleClass="p-datatable-striped" [(selection)]="selection" (onRowSelect)="rowSelected($event)" selectionMode="single" dataKey="id">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="8 +(canEdit ? 1 : 0) + (canSelect ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w--radiobutton" *ngIf="canSelect && (true != isACP)"></th>
            <th>Type</th>
            <th>Address</th>
            <th>Ste, Apt, Etc.</th>
            <th>In Care Of</th>
            <th>City</th>
            <th>State</th>
            <th>ZIP Code</th>
            <th>County</th>
            <th>Country</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td *ngIf="canSelect && (true != isACP)"><p-tableRadioButton [value]="data"></p-tableRadioButton></td>
            <td>{{ data.addressType }} <b class="mvd_alert--label" *ngIf="data.isUndeliverable">Undeliverable</b></td>
            <td>{{data.addressLine1}}</td>
            <td>{{data.addressLine2}}</td>
            <td>{{data.inCareOf}}</td>
            <td>{{data.city}}</td>
            <td>{{data.state}}</td>
            <td>
                <ng-container *ngIf="data.countryId == countries.US.id">
                    {{ data.postalZipCode | zipCode }}
                </ng-container>
                <ng-container *ngIf="data.countryId != countries.US.id">
                    {{ data.postalZipCode }}
                </ng-container>
            </td>
            <td>{{data.county}}</td>
            <td>{{data.country}}</td>
            <td *ngIf="canEdit" class="text-center">
                <ng-container *ngIf="!isACP">
                    <a *ngIf="canEdit" [ngClass]="{'disabled': data.isReadOnly}" class="icon--edit" title="Edit Address" href="javascript:void(0);" (click)="updateAddress(data.addressNumberId)"></a>
                </ng-container>
                <ng-container *ngIf="isACP && !data.isReadOnly">
                    <a *ngIf="canEdit" class="icon--edit" title="Edit Address" href="javascript:void(0);" (click)="updateAddress(data.addressNumberId)"></a>
                </ng-container>
                <ng-container *ngIf="isACP && data.isReadOnly">
                    <a class="icon--edit" title="Edit Address" href="javascript:void(0);" (click)="updateAddress(data.addressNumberId, data.isReadOnly)"></a>
                </ng-container>
            </td>
        </tr>
     </ng-template>
</p-table>
